export default __webpack_public_path__ + "static/media/plan1.b96043e7.jpeg";